import { PerformanceDatapoint } from 'owa-analytics';

export function initCollabObjectPerfDatapoint(scenario: string) {
    const dp = new PerformanceDatapoint('getCollabObjectGraphQL', {
        isCore: true,
        logVerbose: true,
    });

    dp.addCustomData({
        owa_1: scenario,
    });
    return dp;
}
